import { render, staticRenderFns } from "./employment-status.vue?vue&type=template&id=55d6c66e"
import script from "./employment-status.vue?vue&type=script&lang=js"
export * from "./employment-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports